import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { PermissionDenied, PermissionEnum, IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import SettingsList from './risk-levels-list';

import cn from './risk-levels.module.css';

const Settings = () => {
  const { activePermissions } = useAppSelector(
    (state) => state.amlDictionaries,
  );

  useEffect(() => {
    let title = 'Risk Levels';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.settingsLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions) {
    if (
      !activePermissions?.includes(PermissionEnum.SECTION_AML_KYC) ||
      !activePermissions.includes(
        PermissionEnum.SETTINGS_RISK_SCORE_RANGES_LIST,
      )
    ) {
      content = <PermissionDenied />;
    } else {
      content = (
        <div className={cn.settings}>
          <div className={cn.settingsTopWrapper}>
            <div className={cn.settingsTitle}>Risk levels</div>
          </div>
          <SettingsList />
          <Outlet />
        </div>
      );
    }
  }

  return content;
};

export default Settings;
